import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { FormModal } from '@ztechapps/webui.form'
import { QuickAddTaskProvider, useQuickAddTaskContext } from '../QuickAddTask'

export const TaskFilterBarAddButton = () => {
  return (
    <QuickAddTaskProvider>
      <TaskFilterBarAddFormModal />
    </QuickAddTaskProvider>
  )
}

const TaskFilterBarAddFormModal = () => {
  const { initialValues, onSubmit, validate, components } = useQuickAddTaskContext()

  return (
    <FormModal
      trigger={({ onClick }) => <BusyButton icon="plus" text="Add Task..." onClick={onClick} />}
      initialValues={initialValues}
      onSubmit={onSubmit}
      validate={validate}
      title="Add new task"
      saveText="Create"
    >
      <components.formInput />
    </FormModal>
  )
}
